import { NavigateFunction } from "react-router-dom";

export const handleEstimate = ({ navigate, link }: { navigate: NavigateFunction; link?: string }) => {
  if (!link) {
    navigate("/estimate");
    return;
  }
  window.open(link, "_blank")?.focus();
};
